module.exports = __webpack_public_path__ + "img/napping is part of the job.55111795.png";